<template>
  <div class="row result_row">
    <div class="col-3 thumbnail_container">
      <div class="thumbnail_container_inner" @click.stop="parent.goToCareerDetail(source)">
        <template v-if="source.thumbnailURI">
          <img v-if="source.thumbnailURI"
            v-bind:src="source.thumbnailURI"
            alt="Img"
            class="thumb_img"
            onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/career-default.svg';">
        </template>
        <template v-else>
          <div class="default_thumb">
            <span class="ic ic-career"></span>
          </div>
        </template>
      </div>

      <div class="more_details">
        <template v-if="parent.isBookmarkEnabled">
          <span v-if="parent.showBookmarkOnResult && parent.isBookmarked(source)">
            <span class="ic_bm_container bookmarked ace_sec_txt" @click.stop.prevent="parent.deleteCareerBookmark(source)" title="remove this career from bookmark">
              <span class="icon ic8-bookmark3"></span>
            </span>
          </span>
          <span v-else-if="parent.showBookmarkOnResult && !parent.isBookmarked(source)">
            <span class="ic_bm_container ace_sec_txt" @click.stop.prevent="parent.bookmarkCareer(source)" title="bookmark this career">
              <span class="ic ic8-bookmark3"></span>
            </span>
          </span>
        </template>

        <div class="program_desc">
          <b-link v-b-modal="'progDesc_' + source.uuid">more</b-link>
          <b-modal :id="'progDesc_' + source.uuid" :title="source.name" hide-footer>
            <div slot="modal-header" class="row header-section">
              <div class="col-11 head_txt">{{ source.name }}</div>
              <div class="col-1 btn_container">
                <button type="button" class="btn_close" @click="parent.closeDescriptionModal('progDesc_' + source.uuid)" data-dismiss="modal" aria-label="Close">
                  <span class="ic-close"></span>
                </button>
              </div>
            </div>
            <div v-if="parent.showDescriptionOnResult && source.description" v-html="source.description"></div>
          </b-modal>
        </div>

      </div>

    </div>

    <div class="col-9 entity_details">
      <div class="row entity_title" @click.stop="parent.goToCareerDetail(source)">
        <span>{{source.name}}</span>
      </div>
      <div class="row">
        <span v-if="parent.showCalculateRequiredSkillOnResult && parent.isStudentLogin && parent.planningStream" @click="parent.calculateSkillProgressClicked(source, $event)" style="color: #74aac2;">Calculate Required Skills</span>
      </div>
      <div v-if="parent.showMedianIncomeOnResult" class="row">
        <div class="label">{{parent.medianIncomeResultLabel}}</div>
        <div class="val" v-if="source.medianIncomePerYear">
          {{parent.currencyLabel}} <span v-html="parent.addCommaInNumber(source.medianIncomePerYear)"></span>
        </div>
        <div class="val no_data" v-else>
          <span class="no_data_msg2">Data Unavailable</span>
        </div>
      </div>
      <div v-if="parent.showJobPostingsOnResult" class="row">
        <div class="label">{{parent.jobPostingsResultLabel}}</div>
        <div class="val" v-if="source.openings">
          <span v-html="parent.addCommaInNumber(source.openings)"></span>
        </div>
        <div class="val no_data" v-else>
          <span class="no_data_msg2">Data Unavailable</span>
        </div>
      </div>
      <div v-if="parent.showGrowthRateOnResult" class="row">
        <div class="label">{{parent.growthRateResultLabel}}<span class="exclamation-circle" v-popover:tooltip="'Source: BLS. 2016-2026'"><span class="ico-error"></span></span></div>
        <div class="val" v-if="source.growth">{{parseFloat(source.growth).toFixed(1)}}%</div>
        <div class="val no_data" v-else>
          <span class="no_data_msg2">Data Unavailable</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'careerItem',
  props: {
  	parent: {
  		type: Object
  	},
  	index: {
      type: Number
    },
    source: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/explore/components/CareerItem.vue